// extracted by mini-css-extract-plugin
export var content = "_nx-1";
export var fullScreen = "_nx-0";